import * as React from "react";
import { cn } from "@/lib/utils";

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "sage" | "paper" | "clay" | "line";
}

export function Badge({
  className,
  variant = "sage",
  children,
  ...props
}: BadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium tracking-wide",
        variant === "sage" && "bg-sage/15 text-sage border border-sage/30",
        variant === "paper" && "bg-paper-deep text-ink border border-line",
        variant === "clay" && "bg-clay/10 text-clay border border-clay/20",
        variant === "line" && "bg-paper text-ink-soft border border-line",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
